import React from 'react';
import { useLocation } from 'react-router-dom';

import { PageLayout } from 'src/core/components';
import { OligosForm } from 'src/components';
import { OligoForm } from 'src/models';

import messages from './messages';
import './RNAOligosPage.scss';

export const RNAOligosPage = () => {
  const searchParams = useLocation().search;
  const stealth = new URLSearchParams(searchParams)?.get(OligoForm.STEALTH) || false;

  return (
    <div className="oligos-page">
      <PageLayout
        title={messages.pageTitle}
      >
        <OligosForm stealth={stealth} />
      </PageLayout>
    </div>
  );
};

export default RNAOligosPage;
